import React from 'react';
import { InputQ1Wrapper } from '../styles';
import { Q1Value } from 'models/documents';
import { UserDecimalSep } from 'models/user';
import utils from 'utils';
import actions from 'state/actions';
import { FieldInputType, FieldTriggerConfig } from 'models/response';
import MultiLinearInput from '../FieldType/MultiLinearInput';
import NumberInputType from '../FieldType/NumberInputType';

interface NumberInputProps {
  field: any;
  helpers: any;
  multi?: boolean;
  index?: number;
  label: string;
  readonly: boolean;
  feedbackColor: string;
  hasFeedback: boolean;
  feedbackMessage: string;
  separator: UserDecimalSep;
  autoViewInPage: () => void;
  dispatch: any;
  fieldInputType: FieldInputType;
  name: string;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  icon: JSX.Element;
  triggerConfig: FieldTriggerConfig | null;
  executeActionQ1: () => void;
}

export const NumberInputComponent: React.FC<NumberInputProps> = ({
  field,
  helpers,
  multi,
  index,
  label,
  readonly,
  feedbackColor,
  hasFeedback,
  feedbackMessage,
  separator,
  autoViewInPage,
  dispatch,
  fieldInputType,
  name,
  onKeyDown,
  icon,
  triggerConfig,
  executeActionQ1,
}) => {
  const inputIndex = multi ? index || 0 : 0;
  const value = multi && (index || index === 0) ? field.value.content[index].content : field.value.content[0].content;

  const handleChange = (value: number | undefined) => {
    if (field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi ? index ?? 0 : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: value ? `${value}` : '',
        confidence: -1,
        status: 0,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
      if (triggerConfig) executeActionQ1();
    }
  };

  const handleBlur = (value: number | undefined) => {
    if (value && field.value) {
      const values: Q1Value = {
        ...field.value,
      };
      values.content[inputIndex] = {
        ...values.content[inputIndex],
        status: 3,
      };
      helpers.setValue(values);
    }
  };

  const onFocus = () => {
    autoViewInPage();
    field.value && dispatch(actions.documents.setFocussedQ1({ fieldInputType, name, multi, index }));
  };

  const handleChangeMultiLinear = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: e && e.target.value ? e.target.value : '',
        boundingBox: { x1: -1, x2: -1, y1: -1, y2: -1 },
        pageNumber: -1,
        confidence: -1,
        status: 0,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
    }
  };

  const handleBlurMultiLinear = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value && field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: e.target.value,
        status: 3,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
    }
  };

  return (
    <>
      {multi ? (
        <>
          <InputQ1Wrapper multi={multi} margin="0 0 0 -4px">
            <MultiLinearInput
              id={name}
              feedbackColor={feedbackColor}
              hasFeedback={hasFeedback}
              feedbackMessage={feedbackMessage}
              disabled={readonly}
              value={value}
              name={name}
              onFocus={onFocus}
              onKeyDown={onKeyDown}
              onBlur={(e) => handleBlurMultiLinear(e)}
              onChange={handleChangeMultiLinear}
              width={'160px'}
              margin="0px"
              borderRadius="4px"
              typeOfField="number"
              index={index}
              values={[...field.value.content]}
              field={field}
              helpers={helpers}
            />
          </InputQ1Wrapper>
          {icon}
        </>
      ) : (
        <InputQ1Wrapper multi={multi} margin="0px 6px 0 0">
          <NumberInputType
            feedbackColor={feedbackColor}
            hasFeedback={hasFeedback}
            feedbackMessage={feedbackMessage}
            decimalScale={0}
            onFocus={onFocus}
            value={utils.intl.convertToNumber(value)}
            readonly={readonly}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={onKeyDown}
            label={label}
            multi={multi}
            decimalSeparator={separator}
            width="200px"
            display="flex"
            margin="0 4px 0 0"
          />
          {icon}
        </InputQ1Wrapper>
      )}
    </>
  );
};
